import {
  ModeltypeBasicDto,
  ModelyearDto,
  TechnicalDataDto,
} from 'src/services/Client';
import { IReduxState } from '../IReduxState';

export const selectDerivates = (
  state: IReduxState
): ModeltypeBasicDto[] | undefined => state.technicalData.derivates;

export const selectTechnicalData = (
  state: IReduxState
): TechnicalDataDto[] | undefined => state.technicalData.technicalData;

export const selectTechnicalDataDerivates = (
  state: IReduxState
): ModeltypeBasicDto[] => state.technicalData.technicalDataDerivates;

export const selectUserModelyearsElements = (state: any): ModelyearDto[] =>
  state.general.userModelyears.elements;



// WEBPACK FOOTER //
// ./src/redux/selectors/technicalDataSelector.ts